import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NotificationState {
  private readonly notificationsSubject = new BehaviorSubject<any[]>([]);
  private readonly notificationTotalCountSubject =
    new BehaviorSubject<number>(0);

  readonly notifications$ = this.notificationsSubject.asObservable();
  readonly notificationTotalCount$ =
    this.notificationTotalCountSubject.asObservable();

  get notificationsValue(): any[] {
    return this.notificationsSubject.value;
  }

  set notificationsValue(notifications: any[]) {
    this.notificationsSubject.next(
      Array.isArray(notifications) ? notifications : []
    );
  }

  get notificationTotalCountValue(): number {
    return this.notificationTotalCountSubject.value;
  }

  set notificationTotalCountValue(count: number) {
    this.notificationTotalCountSubject.next(count || 0);
  }

  reset(): void {
    this.notificationsSubject.next([]);
    this.notificationTotalCountSubject.next(0);
  }
}